import React, {useCallback, useEffect, useState} from 'react';
import {Handle, Position} from "react-flow-renderer";
import Select from 'react-select';
import RightClickMenu from "./Components/RightClickMenu";


const style = {
    outline: "2px solid orange",

}

const options = [
    {value: '==', label: '=='},
    {value: '!=', label: '!='},
    {value: '>', label: '>'},
    {value: '<', label: '<'},
    {value: '<=', label: '<='},
    {value: '>=', label: '>='},
];

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        // borderBottom: '1px dotted pink',
        color: state.isSelected ? 'white' : 'black',
        padding: 7,


    }),
    control: () => ({
        // none of react-select's styles are passed to <Control />
        width: 150,
        display: "flex",
        flexDirection: "row",
        textAlign: 'right',

    }),
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        const color = "rgb(255, 255, 255,90%)";
        return {...provided, opacity, transition, color};
    }
}

const ShowIf = ({data, id}) => {
    // const onChange = useCallback((evt) => {
    //
    // }, []);

    const theme = (theme) => ({
        ...theme,
        borderRadius: 0,
        colors: {
            ...theme.colors,
            primary25: 'hotpink',
            primary: 'black',
        },
    })

    // const [selectedOption, setSelectedOption] = useState({type:""});
    const [stl, setStl] = useState({})
    const [active, setActive] = useState(false)
    const [variables, setVariables] = useState([])
    const [isVis, setIsVis] = useState(false)
    const [opt1, setopt1] = useState('')
    const [opt2, setopt2] = useState('')
    const [opt3, setopt3] = useState('')
    const [menu, showMenu] = useState(false)

    const onDoubleClick = useCallback(() => {
        setActive(true)
        setStl(style)
        setIsVis(true)
    }, [])


    const DisableActive = useCallback(() => {
        setStl({})
        setActive(false)
        setIsVis(false)

        showMenu(false)

    }, [])




    useEffect(() => {
        data.ActivFun = DisableActive
        data.active = onDoubleClick

        const vars = JSON.parse(localStorage.getItem('variables'))


        if (vars !== null) {


            let qqe = []
            for (const vaer of vars) {

                qqe.push({value: vaer.name, label: `${vaer.name} (${vaer.type})`, type: vaer.type})
            }
            setVariables(qqe)
        }

        setopt1({
            value: data.condition.name,
            label: `${data.condition.name} (${data.condition.type})`,
            type: data.condition.type
        })
        setopt2({value: data.condition.sign, label: data.condition.sign})
        setopt3(data.condition.value)


    }, [isVis])




    return (

        <div
            style={stl}
            className="If-node"
        >{menu && <RightClickMenu data={data} id={id}/>}
            <Handle type="target" className="MainIne" position={Position.Left} id="in"/>
            <Handle type="source" className="MainOute" position={Position.Right} id="out"/>

            {!isVis &&
                <>
                    <label>If:</label>
                    <div style={{fontStyle: "italic"}}>{`${opt1.label} ${opt2.label} ${opt3}`}</div>
                </>
            }


            {isVis &&
                <Select
                    options={variables}

                    theme={theme}

                    styles={customStyles}
                    className="selectReact"
                    value={opt1}
                    // defaultValue={data.value_1}
                    onChange={(e) => {
                        setopt1(e)
                        data.condition.name = e.value
                        data.condition.type = e.type
                    }}
                />
            }

            {isVis &&
                <Select
                    options={options}
                    theme={theme}
                    styles={customStyles}
                    className="selectReact"
                    // defaultValue={null}
                    // onChange={setSelectedOption}
                    value={opt2}
                    // defaultValue={data.condition}
                    onChange={(e) => {
                        data.condition.sign = e.value
                        setopt2(e)
                    }}
                />
            }

            {isVis &&
                <input style={{background: "white", outline: "0", border: "0", padding: "6px"}}
                       value={opt3}
                       defaultValue={data.value_2}
                       onChange={(e) => {

                           setopt3(e.target.value)
                           data.condition.value = e.target.value
                       }}/>
            }

            {!active && <div onContextMenu={
                event => {
                    event.preventDefault()
                    showMenu(!menu)
                }
            } className="Shild"></div>}


        </div>
    );
};

export default ShowIf